import { useForm } from "react-hook-form";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { Suspense, useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Grid2, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import { exportExcel } from "../../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import { AxiosResponse } from "axios";
import { getEmisores } from "../../../../services/servicesDominio";
import { StatusCode, TipoFuncionalidad } from "../../../../utils/enums";
import { selectorTransversal } from "../../../../dtos/selector";
import { FilterList } from "@mui/icons-material";
import { useColumns } from "../utils/columns";
import { CobranzaJudicialDTO, Iprops } from "../models/cobranzaJudicial";
import { useCobranzaJudicial } from "../hooks/useCobranzaJudicial";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { updateCobranzaJudicial } from "../service/serviceCobranzaJudicial";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";
import { useToast } from "../../../../hooks/useToast";
import Tabla from "../../../../components/ui/materialui/tablaServerSelector";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { Emisor } from "../../../reportes/generarProcesosMasivos/models/generarArchivoProcesosMasivos";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { getCurrentUsername } from '../../../../services/userRolesService';

export interface IProps {
    emisor: string;
    esAdministrado: boolean;

}

function CobranzaJudicial() {
    const [modalDetalle, setModalDetalle] = useState<boolean>(false);
    const [optionsEmisor, setOptionsEmisor] = useState<selectorTransversal[]>([]);
    const [filasSeleccionada, setFilasSeleccionadas] = useState<CobranzaJudicialDTO[]>([]);
    const [show, setShow] = useState(false);
    const { addToast } = useToast();

    const urlTabla = `siscred-api-maestros/v1/cobranzajudicial/listar`;

    const controlTabla = useDataFetch(
        urlTabla,
        new URLSearchParams('filters.status=Activo'),
        true,
    )

    const {
        formState: { errors },
        control,
        handleSubmit,
        setValue,
        reset,
        watch
    } = useForm<Iprops>({
        mode: "onBlur",
        defaultValues: {
            emisor: "Todos",
            esAdministrado: true,
        },
    });

    const dataForm = watch();
    const { data, getCobranza } = useCobranzaJudicial();

    const { COLUMNS } = useColumns({ controlTabla });
    const columns = useMemo(() => COLUMNS, [controlTabla]);

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Cobranzas', url: `/cobranzas` },
        { label: 'Cobranza judicial', active: true },
    ]

    const tipoEmisor = async () => {
        const resp: AxiosResponse<ListResponseDto<Emisor>> = await getEmisores();
        if (resp.status === 200) {
            const data: Emisor[] = await resp.data.items;
            const options = data.map((m: any) => ({
                label: m.nombre,
                value: m.rut,
            })); setOptionsEmisor([{ label: "Todos", value: "Todos" }, ...options]);
        }
        return;
    }

    useEffect(() => {
        const inicializar = async () => {
            await tipoEmisor();
        };
        inicializar();
    }, []);


    const handleEliminar = async () => {
        if (filasSeleccionada.length === 0) {
            return;
        }

        const login = getCurrentUsername();

        const payload = filasSeleccionada.map(fila => ({
            id: Number(fila.mutuoId),
            esAdministrado: fila.esAdministrado ? "Y" : "N",
            estado: "N",
            abogado: "",
            login
        }));

        const resp = await updateCobranzaJudicial(payload);
        if (resp.status === StatusCode.NoContent) {
            setShow(false);
            await getCobranza(dataForm);
            
            setFilasSeleccionadas([]);
            addToast({
                mostrar: true,
                titulo: 'Éxito',
                tipo: 'Success',
                mensaje: 'Cobranza judicial se ha actualizado correctamente.'
            });
            customOnHide();
            controlTabla.fetchData();


        }

    };

    function customOnHide() {
        reset()
    }

    const onSubmit = (data: IProps) => {
        controlTabla.manejarCambiosFiltros('filters.emisor', data.emisor || '');
        controlTabla.manejarCambiosFiltros('filters.esAdministrado', data.esAdministrado ? "Y" : "N");

        controlTabla.fetchData();


        setFilasSeleccionadas([]);
    };


    const mayorAuno = filasSeleccionada.length === 1 ? true : false;

    return (
        <>
            <Suspense>
                <Breadcrumb items={breadcrumbItems} />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <CustomAccordion
                                title='Filtros'
                                expandedDefault
                            >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid2 container spacing={2}>
                                        <Grid2 size={3}>
                                            <InputSelect
                                                name="emisor"
                                                control={control}
                                                label="Emisor"
                                                options={optionsEmisor}
                                            />
                                        </Grid2>

                                        <Grid2 size={3}>
                                            <InputSwitch
                                                name="esAdministrado"
                                                control={control}
                                                label='Es administrado'
                                            />
                                        </Grid2>
                                        <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_ver]}>
                                            <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                                                Filtrar
                                            </MButton>
                                            </PermissionGuard>
                                        </Grid2>
                                    </Grid2>
                                </form>
                            </CustomAccordion>

                            <Tabla
                                url={urlTabla}
                                columns={columns}
                                control={controlTabla}
                                esMultiple={true}
                                callApi={false}
                                setFilaSeleccionada={setFilasSeleccionadas}
                                titulo={
                                    <TableHeader
                                        title=""
                                        control={controlTabla}
                                        button={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_adm]}>
                                            <MButton
                                                type="button"
                                                variant="contained"
                                                color="error"
                                                onClick={() => {
                                                    if (filasSeleccionada.length === 0) {
                                                        addToast({
                                                            mostrar: true,
                                                            titulo: 'Advertencia',
                                                            tipo: 'Warning',
                                                            mensaje: 'Debe seleccionar al menos una fila para eliminar.'
                                                        });
                                                        return;
                                                    }
                                                    setShow(true);
                                                }}
                                                startIcon={<GridDeleteIcon />}
                                            >
                                                Eliminar
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                        buttonExport={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                onClick={() => exportExcel(controlTabla.data, columns, "Cobranza Judicial")}
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Exportar
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                    />
                                }
                            />
                        </Suspense>
                    </Paper>
                </Box>
            </Suspense>

            <ConfirmationModal
                show={show}
                onHide={() => setShow(false)}
                onConfirm={handleEliminar}
                title="Confirmar eliminación"
                message={mayorAuno
                    ? "¿Está seguro de grabar el mutuo seleccionado?"
                    : "¿Está seguro de grabar los mutuos seleccionados?"
                }
                size="sm"
            />
        </>
    );
}

export default CobranzaJudicial;
